<div class="frontoffice-root">
  <app-navbar></app-navbar>

  <!--Hardcodeado por el momento-->
  <app-cerrado></app-cerrado>
  <!--Hardcodeado por el momento-->

  <router-outlet></router-outlet>

  <app-footer></app-footer>
</div>
